type AnalyticsDashboardLocationEvent = {
  metabase: {
    type: "location";
    location: {
      href: string;
      origin: string;
      protocol: string;
      host: string;
      hostname: string;
      port: string;
      pathname: string;
      search: string;
      hash: string;
    };
  };
};

export function isAnalyticsDashboardLocationEvent(
  data: unknown
): data is AnalyticsDashboardLocationEvent {
  return (
    typeof data === "object" &&
    data !== null &&
    "metabase" in data &&
    typeof data.metabase === "object" &&
    data.metabase !== null &&
    "type" in data.metabase &&
    data.metabase.type === "location" &&
    "location" in data.metabase &&
    typeof data.metabase.location === "object" &&
    data.metabase.location !== null
  );
}
